import React, { useState } from "react";

import { useParams } from "react-router-dom";

import {
  NinVerificationInput,
  NinVerificationRes,
} from "types/verification.type";
import {
  verifyDriverLicence,
  verifyNin,
  verifyVoterCard,
} from "services/verification.service";
import { useMutation } from "react-query";
import {
  resendGuarantorMessage,
  verifyKyc,
  verifyUserGuarantor,
} from "services/user.service";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import useKycReport from "hooks/useKycReport";
import { Guarantor } from "types/mynda.interface";

interface Props {
  data: Guarantor;
  refetch: () => void;
}
const GuarantorCard = ({ data, refetch }: Props) => {
  const params = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationUser, setValidationUser] = useState({
    firstName: "",
    lastName: "",
    // email: "",
    phoneNumber: "",
    occupation: "",
  });

  const { data: report, isLoading: loadin } = useKycReport(params.id!);

  const { mutate: updateKyc, isLoading: isPending } = useMutation(
    (input: { isVerified: boolean; id: number }) =>
      verifyKyc(params.id!, input.id, input.isVerified),
    {
      onSuccess() {
        // refetch();
      },
    }
  );

  const handleVerification = async (value: boolean) => {
    updateKyc({ id: 1, isVerified: value });
    await verifyUserGuarantor(data?._id);
  };

  const { isLoading: isSesndin, mutate } = useMutation(
    (userId: string) => resendGuarantorMessage(userId),
    {
      onSuccess(data) {
        toast(data?.message);
      },
      onError(error: any) {
        toast(error?.response?.data?.message, { type: "error" });
      },
    }
  );

  const handleDocVerification = async (val: string) => {
    setValidationUser({
      firstName: "",
      lastName: "",
      // email: "",
      phoneNumber: "",
      occupation: "",
    });
    if (data?.guarantorConsent?.docType?.toLowerCase()?.includes("nin")) {
      handleNinVerification(val);
    }
    if (
      data?.guarantorConsent?.docType?.toLowerCase().includes("voters card")
    ) {
      handleVoterCardVerification(val);
    }
    if (
      data?.guarantorConsent?.docType?.toLowerCase().includes("driverlicense")
    ) {
      handleDriverLicenceVerification(val);
    }
  };

  const handleNinVerification = async (nin: string) => {
    const firstName = data?.guarantorConsent?.firstName;
    const lastName = data?.guarantorConsent?.lastName;
    try {
      setErrorMessage("");
      setLoading(true);
      const ninPayload: NinVerificationInput = {
        nin,
        type: "guarantor",
      };
      const res = await verifyNin(ninPayload, data._id!);
      const info = res.data as NinVerificationRes;
      setValidationUser({
        firstName: info.first_name,
        lastName: info.last_name,
        phoneNumber: info.phone_number,
        occupation: "",
      });

      refetch();

      // if (
      //   info.first_name?.toLowerCase() !== firstName?.toLowerCase() &&
      //   info.last_name.toLowerCase() !== lastName?.toLowerCase()
      // ) {
      //   setErrorMessage(
      //     "first and last name does not match with provided Identity"
      //   );

      //   return;
      // }

      if (
        info.first_name.toLowerCase().trim() !== firstName?.toLowerCase().trim()
      ) {
        setErrorMessage(" first name does not match with provided Identity");

        return;
      }
      if (
        info.last_name?.toLowerCase().trim() !== lastName?.toLowerCase().trim()
      ) {
        setErrorMessage("last name does not match with provided Identity");

        return;
      }
    } catch (error: any) {
      setErrorMessage(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVoterCardVerification = async (vin: string) => {
    try {
      setErrorMessage("");

      setLoading(true);
      const gfirstName = data?.guarantorConsent?.firstName;
      const glastName = data?.guarantorConsent?.lastName;

      const info = await verifyVoterCard(vin, data?._id!, "guarantor");
      const [firstName, _, lastName] = info.data.full_name.split(" ");

      setValidationUser({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: info.data?.phone,
        occupation: info?.data?.occupation,
      });
      refetch();

      // if (
      //   firstName?.toLowerCase() !== gfirstName?.toLowerCase() &&
      //   lastName.toLowerCase() !== glastName?.toLowerCase()
      // ) {
      //   setErrorMessage(
      //     "first and last name does not match with provided Identity"
      //   );

      //   return;
      // }

      if (firstName.toLowerCase().trim() !== gfirstName?.toLowerCase().trim()) {
        setErrorMessage("first name does not match with provided Identity");

        return;
      }
      if (lastName?.toLowerCase().trim() !== glastName?.toLowerCase().trim()) {
        setErrorMessage("last name does not match with provided Identity");

        return;
      }
    } catch (error: any) {
      setErrorMessage(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDriverLicenceVerification = async (licenceNumber: string) => {
    try {
      setErrorMessage("");
      setLoading(true);

      const gfirstName = data?.guarantorConsent?.firstName;
      const glastName = data?.guarantorConsent?.lastName;

      const info = await verifyDriverLicence(
        licenceNumber,
        data._id!,
        "guarantor"
      );
      const firstName = info.data.firstName;
      const lastName = info.data.lastName;

      setValidationUser({
        firstName,
        lastName,
        phoneNumber: "",
        occupation: "",
      });

      refetch();

      // if (
      //   firstName?.toLowerCase() !== gfirstName?.toLowerCase() &&
      //   lastName.toLowerCase() !== glastName?.toLowerCase()
      // ) {
      //   setErrorMessage(
      //     "first and last name does not match with provided Identity"
      //   );

      //   return;
      // }

      if (firstName.toLowerCase().trim() !== gfirstName?.toLowerCase().trim()) {
        setErrorMessage("first name does not match with provided Identity");

        return;
      }
      if (lastName?.toLowerCase().trim() !== glastName?.toLowerCase().trim()) {
        setErrorMessage("last name does not match with provided Identity");

        return;
      }
    } catch (error: any) {
      setErrorMessage(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotif = () => {
    mutate(data?._id!);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="flex flex-col gap-4">
        <div>
          {errorMessage && <p className="text-red-500">{errorMessage}</p>}

          <div className="flex items-center gap-4 mt-8">
            {data?.consent?.toLowerCase() === "approved" &&
              !data.verifiedInfo && (
                <button
                  type="button"
                  onClick={() =>
                    handleDocVerification(data.guarantorConsent?.docNumber!)
                  }
                  // disabled={data?.data?.user?.accountVerified}
                  className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 "
                >
                  {loading ? "Processing..." : "  Verify Document"}
                </button>
              )}

            <div className="flex items-center gap-4 ">
              {loading ? null : (
                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                  <button
                    disabled={!data?.verifiedInfo || report?.data[1]?.verified}
                    onClick={() => handleVerification(true)}
                    className="text-white transition-all duration-200 ease-linear btn disabled:opacity-50 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    {report?.data[1]?.verified
                      ? "Verified"
                      : isPending
                      ? "Loading..."
                      : "Mark as verify"}
                  </button>
                </div>
              )}
              {data && (
                <button
                  type="button"
                  onClick={handleSendNotif}
                  // disabled={data?.data?.user?.accountVerified}
                  className="text-white transition-all duration-200 ease-linear btn bg-red-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-red-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-red-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 "
                >
                  {isSesndin ? "Sending..." : "Send Reminder"}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="card flex  flex-col lg:flex-row  justify-between gap-8 w-full">
            <div className="card-body w-full  ">
              <div className="w-full overflow-x-auto ">
                <table data-stack className="w-full  ">
                  <thead>
                    <tr>
                      <th className=" text-left">Label</th>
                      <th className=" text-left">User Provided Information</th>

                      <th className=" text-left">
                        Gurantor Provided Information
                      </th>
                      <th className=" text-left">
                        Guarantor Verification Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th
                        className="text-left py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        First Name
                      </th>
                      <td data-label="User provided" className="text-left py-2 text-slate-500 dark:text-zink-200">
                        {data?.fullName?.split(" ")[0] ?? ""}{" "}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.firstName}{" "}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.firstName}{" "}
                      </td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Last Name
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.fullName.split(" ")[1] ?? ""}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.lastName}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.lastName}
                      </td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Relationship
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.relationship}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.relationship}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200"></td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Email
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.email}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.email}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.email}
                      </td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Phone
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.phone}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.phone}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.phoneNumber}
                      </td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Address
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.address}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.address}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.address}
                      </td>
                    </tr>
                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Ducument Provided
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200"></td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.docType}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.verifiedInfo?.type}
                      </td>
                    </tr>
                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Ducument Number
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200"></td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.docNumber}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200"></td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Occupation
                      </th>
                      <td data-label="User provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.occupation}
                      </td>
                      <td data-label="Guarantor provided" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.occupation}
                      </td>
                      <td data-label="Verification" className="py-2 text-left text-slate-500 dark:text-zink-200"></td>
                    </tr>

                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Identity Document
                      </th>
                      <td data-cell="hide"></td>
                      <td data-cell="block" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.document && (
                          <a
                            href={data?.guarantorConsent?.document?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {data?.guarantorConsent?.document?.name ||
                              "View Document"}
                          </a>
                        )}
                        <td data-cell="hide"></td>
                      </td>

                      <td data-cell="block" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.document && (
                          <a
                            href={data?.guarantorConsent?.document?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {data?.guarantorConsent?.document?.name ||
                              "View Document"}
                          </a>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Guarantor Consent
                      </th>
                      <td data-cell="block" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.consent}
                      </td>
                      <td data-cell="block" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.consent}
                      </td>
                    </tr>
                    <tr>
                      <th
                        className="py-2 text-left font-semibold ps-0"
                        scope="row"
                      >
                        Guarantor Photo
                      </th>
                      <td data-cell="hide"></td>
                      <td data-cell="block" className="py-2 text-left text-slate-500 dark:text-zink-200">
                        {data?.guarantorConsent?.photo && (
                          <img
                            src={data?.guarantorConsent?.photo.url}
                            alt=""
                            className=" w-full max-w-[200px] h-auto aspect-square rounded-sm"
                          />
                        )}
                      </td>
                      {data?.verifiedInfo?.image && (
                        <img
                          src={`data:image/png;base64,${data?.verifiedInfo?.image}`}
                          alt=""
                          className=" w-full max-w-[200px] h-auto aspect-square rounded-sm"
                        />
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GuarantorCard;
